import { useEffect, useState } from 'react';
import { LoadingImage } from '@/components/Loading';
import { cn } from '@/utils/tailwind.util';
export const DelayedLoadingFallback = ({
  delayMS,
  subText,
  className
}: {
  /** delayMS 후 로딩 화면이 보여집니다 */
  delayMS: number;
  subText?: string;
  className?: string;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delayMS);
    return () => clearTimeout(timer);
  }, [delayMS]);
  return isVisible ? <div className={cn('flex flex-col items-center justify-center gap-xs', className)} data-sentry-component="DelayedLoadingFallback" data-sentry-source-file="DelayedLoadingFallback.tsx">
      <LoadingImage data-sentry-element="LoadingImage" data-sentry-source-file="DelayedLoadingFallback.tsx" />
      {subText && <span className="text-body-md-bold text-alternative">{subText}</span>}
    </div> : null;
};